import { t } from '@bms2/shared';
import styles from './SuggestionDot.module.css';

/** What the dot sits beside: a person or, since T3066, a company, which words its title for itself. */
export type DotSubject = 'person' | 'company';

/**
 * 🔒 The gold dot beside a person's or a company's name wherever they are listed (piece 13;
 * T3028, T3066): the person's latest checks hold an open suggestion to look at. It is
 * titled in words for a pointer and a screen reader, and it reads the list's own
 * flag, so drawing it looks nothing up.
 */
export function SuggestionDot({ subject = 'person' }: { subject?: DotSubject }) {
  const title = t(subject === 'company' ? 'recordChecks.dot.companyTitle' : 'recordChecks.dot.title');
  return <span className={styles.dot} role="img" aria-label={title} title={title} data-suggestion-dot="true" />;
}

/** The dot where a row's flag says so, and nothing otherwise. */
export function suggestionDotFor(flagged: unknown, subject: DotSubject = 'person') {
  return flagged === true || flagged === 1 ? <SuggestionDot subject={subject} /> : null;
}
